import { useCallback } from 'react';
import type {
  ArticleHeroMediaAlign,
  ArticleHeroMediaSize,
  ArticleHeroMediaVerticalAlign,
} from '../../../../shared/domain/articleHeroMedia';
import { logArticleHeroMediaLayout } from '../../lib/logArticleHeroMediaLayout';

interface ArticleHeroMediaImageProps {
  url: string;
  size: ArticleHeroMediaSize;
  align: ArticleHeroMediaAlign;
  verticalAlign: ArticleHeroMediaVerticalAlign;
  scale: number;
}

export function ArticleHeroMediaImage({
  url,
  size,
  align,
  verticalAlign,
  scale,
}: ArticleHeroMediaImageProps) {
  const handleLoad = useCallback((event: React.SyntheticEvent<HTMLImageElement>) => {
    const image = event.currentTarget;
    logArticleHeroMediaLayout('imageLoad', {
      kind: 'image',
      size,
      align,
      verticalAlign,
      scale,
      viewportWidth: image.clientWidth,
      viewportHeight: image.clientHeight,
      naturalWidth: image.naturalWidth,
      naturalHeight: image.naturalHeight,
    });
  }, [align, verticalAlign, scale, size]);

  return (
    <img
      src={url}
      alt=""
      className="article-hero-media__asset"
      loading="lazy"
      decoding="async"
      onLoad={handleLoad}
    />
  );
}
